import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StoryTemplateForm } from '@/forms/StoryTemplateForm';
import { createStoryTemplate } from '@/api/services/story-templates/createStoryTemplate';
import type { CreateStoryTemplateRequest } from 'schemas';
import type { ApiError } from '@/api/ApiError';
import { createStoryTemplatePageMessages } from './createStoryTemplatePage.messages';
import { ROUTES } from '@/routes';
import { DashboardPageContainer } from '@/components/layout/DashboardPageContainer';
import { toast } from 'sonner';

export function CreateStoryTemplatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (formData: CreateStoryTemplateRequest) => {
    setIsSubmitting(true);

    try {
      const result = await createStoryTemplate(formData);
      if (result) {
        // Navigate back to story templates page
        navigate(ROUTES.DASHBOARD_STORY_TEMPLATES);
      }
    } catch (error: unknown) {
      // createStoryTemplate ensures the error will be an ApiError
      toast.error((error as ApiError).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(ROUTES.DASHBOARD_STORY_TEMPLATES);
  };

  return (
    <DashboardPageContainer
      headline={createStoryTemplatePageMessages.pageTitle}
      subheading={createStoryTemplatePageMessages.pageDescription}
    >
      <div aria-label={createStoryTemplatePageMessages.formContainerAriaLabel}>
        <StoryTemplateForm
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={handleCancel}
        />
      </div>
    </DashboardPageContainer>
  );
}
